export const BASE_URL =
  (process.env.REACT_APP_API_URL || "http://localhost:8000").replace(
    /\/+$/,
    ""
  );

export const API_V1_BASE_URL = `${BASE_URL}/api/v1`;

const generateRoute = (route: string) => ({
  LIST: `/${route}`,
  CREATE: `/${route}/create`,
  EDIT: `/${route}/edit`,
});

export const ROUTE = {
  USER_SETTING: generateRoute("setting/users"),
  DATASET_SETTING: generateRoute("setting/datasets"),
  DATALAKE_SETTING: generateRoute("setting/datalake"),
  DATA_WAREHOUSE_SETTING: generateRoute("setting/data-warehouse"),
  ROLE_SETTING: generateRoute("setting/roles"),
  MENU_SETTING: generateRoute("setting/menus"),
  PERMISSION_SETTING: generateRoute("setting/permissions"),
  CONFIG_SETTING: generateRoute("setting/config"),
  CCTV: generateRoute("cctv"),
  CHANGE_PASSWORD: generateRoute("setting/change-password"),
};

const date = new Date();
const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "Mei",
  "Juni",
  "Juli",
  "Agust",
  "Sept",
  "Okt",
  "Nov",
  "Des",
];
export const today =
  date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
